import React from 'react';
import {
  Checkbox,
  Container,
  ContainerGutter,
  styled,
} from '@volkswagen-onehub/components-core';
import { Filters } from "../../types/filters";
import { getLang } from '../../translations';
import handleClick from '../../utils/handle-click';
import { BasicFilterOption } from '../../types/globalapi/filters';
import { useSelectedFilterStore } from '../../store/filtersv2';

interface Props {
  label: string;
  type: keyof Filters;
  list: BasicFilterOption[];
  columns?: boolean;
  id: string;
}

type ArrayFilter = { [k in keyof Filters]: Filters[k] extends [] ? k : never }[keyof Filters];

const MultiSelectListFieldsetWrapper = styled.div`
  legend {
    font-size: ${props => props.theme.fonts.bigcopy[100].fontSize};
    line-height: ${props => props.theme.fonts.bigcopy[100].lineHeight};
    letter-spacing: ${props => props.theme.fonts.bigcopy[100].letterSpacing};
    color: #001E50 !important;
  }
  [aria-live] {
    margin: 0;
  }
  span[class^=StyledFocusWrapper] {
    margin: 12px 0 0;
  }
`;

export const MultiselectList = ({ label, type, list }: Props) => {
  const lang = getLang();
  const selection: string[] = useSelectedFilterStore().selected[type] as ArrayFilter || [];

  const handleClickEvent = handleClick(label, type);

  return (
    list
    && <MultiSelectListFieldsetWrapper>
        <Container
          gutter={ContainerGutter.static150}
          wrap="always"
        >
          {
            list.map(({label, value}: BasicFilterOption, i: number) => {
              const key = `${type}-${value}-${i}`;
              return (
                <Checkbox
                  key={key}
                  name={type}
                  value={String(value)}
                  label={label[lang]}
                  checked={selection.includes(String(value))}
                  onClick={handleClickEvent}
                />
              )
            })
          }
        </Container>
    </MultiSelectListFieldsetWrapper>
  );
};
